import createIcon from '../../createIcon';

/**
 * @component @name BrowseGallery
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAzQzQuMDMgMyAwIDcuMDMgMCAxMkMwIDE2Ljk3IDQuMDMgMjEgOSAyMUMxMy45NyAyMSAxOCAxNi45NyAxOCAxMkMxOCA3LjAzIDEzLjk3IDMgOSAzWk0xMS43OSAxNi4yMUw4IDEyLjQxVjdIMTBWMTEuNTlMMTMuMjEgMTQuOEwxMS43OSAxNi4yMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy45OSAzLjUyVjUuNjhDMjAuMzYgNi44IDIyIDkuMjEgMjIgMTJDMjIgMTQuNzkgMjAuMzYgMTcuMiAxNy45OSAxOC4zMlYyMC40OEMyMS40OCAxOS4yNCAyNCAxNS45MSAyNCAxMkMyNCA4LjA5IDIxLjQ4IDQuNzYgMTcuOTkgMy41MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrowseGallery = createIcon('BrowseGallery', [
  [
    'path',
    {
      d: 'M9 3C4.03 3 0 7.03 0 12C0 16.97 4.03 21 9 21C13.97 21 18 16.97 18 12C18 7.03 13.97 3 9 3ZM11.79 16.21L8 12.41V7H10V11.59L13.21 14.8L11.79 16.21Z',
      key: 'czamkb',
    },
  ],
  [
    'path',
    {
      d: 'M17.99 3.52V5.68C20.36 6.8 22 9.21 22 12C22 14.79 20.36 17.2 17.99 18.32V20.48C21.48 19.24 24 15.91 24 12C24 8.09 21.48 4.76 17.99 3.52Z',
      key: '1kvhak',
    },
  ],
]);

export default BrowseGallery;
